import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SVGIconComponent } from "@progress/kendo-angular-icons";

@Component({
  selector: 'cu-download-link-cell-renderer',
  template: `
    <div class="text-center selectable-div">
      @if (!params.value.hidden) {
        <kendo-svgicon [icon]="params.icon" (click)="onClick()"></kendo-svgicon>
      }
    </div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SVGIconComponent,
  ],
})
export class PxdAgGridActionRenderer {
  params;

  agInit(params): void {
    this.params = params;

    if (params.action == null) {
      throw new Error('Missing action parameter for PxdAgGridRemoveRenderer');
    }
  }

  onClick(): void {
    this.params.action(this.params);
  }
}

export type CellAction = (params) => void;